import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { AxiosError } from 'axios'

type Params = {
  companyKey: string
  body: FormData
}

export async function uploadCertificate({ companyKey, body }: Params) {
  await httpClient('accounting-dealer').post(
    `/v3/file/${companyKey}/certificate`,
    body,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    },
  )
}

export function useUploadCertificate(
  options?: UseMutationOptions<void, AxiosError, Params, unknown>,
) {
  return useMutation({
    mutationFn: uploadCertificate,
    ...options,
  })
}
